import React, { useState } from 'react';
import CustomButton from 'components/common/custom-button/custom-button';
import * as Styles from './IssueChat.styles';
import moment from 'moment';
import { Icon } from 'semantic-ui-react';
import { Hidden } from '@mui/material';
import { Link } from 'react-router-dom';
import { ErrorMessage, Form, Formik } from 'formik';
import { handleKeyDown, initialValuesOfClosedTicket, validationSchemaOfClosedTicket } from 'components/support/utils';
import { P, SPAN } from 'utils/resuable-css';
import ReactMarkdown from 'markdown-to-jsx';
import { Base64 } from 'js-base64';
import { useTranslation } from 'react-i18next';
import { ChatReplyEditor } from '@sidraaabdullah/test-shared-library';

const IssueChat = ({
  loadingTicketClosed,
  handleTicketClosed,
  handleAddReply,
  addReplyLoading,
  getTicketsDetail,
  isHaveStaffNotes,
}) => {
  const tickets = getTicketsDetail?.tickets[0];
  const [secret, setSecret] = useState('');
  const [editorValue, setEditorValue] = useState('');
  const { t } = useTranslation();
  return (
    <Styles.AllIssueSC>
      <Styles.Container>
        <Styles.TopHeadingContainer>
          {tickets?.properties?.map((data, i) => (
            <Styles.HeadingCon key={i}>
              {data.key !== undefined && data.value !== undefined && (
                <>
                  {data.key === 'fullname' || data.key === 'subject' ? (
                    <Styles.Heading>
                      <span>{data.key}:</span> {Base64.decode(data.value)}
                    </Styles.Heading>
                  ) : (
                    <Styles.MarkdownHeading>
                      <span className="key">{data.key}:</span>{' '}
                      <ReactMarkdown className="line-break">{Base64.decode(data.value)}</ReactMarkdown>
                    </Styles.MarkdownHeading>
                  )}
                </>
              )}
            </Styles.HeadingCon>
          ))}
        </Styles.TopHeadingContainer>

        <Styles.SecondRow>
          <Styles.Flex>
            <P>opened this issue on {tickets?.date_local_format_mdy}</P>
            <Icon className="dot" name="circle" />
            <P>
              <Icon name="comment outline" />
              {tickets !== undefined && tickets?.message_count}
            </P>
          </Styles.Flex>
        </Styles.SecondRow>
        <Styles.Chat>
          {tickets !== undefined &&
            tickets?.ticket_thread?.map((val, index) => (
              <>
                <Hidden only={['xs', 'sm']}>
                  <Styles.ChatMobile key={index}>
                    <Styles.Div1>
                      {/* {val.secret !== '' && <Styles.ClientHeight />} */}
                      <Styles.DateSC vip={val.vip === '1'} bg={val.from_client_or_staff === 'client'}>
                        {val?.from_client_or_staff === 'client' && (
                          <Link className="firstLink" to="/dashboard">
                            {val.vip === '1' && <Icon name="chess queen" className="crown" />}
                            {val.paid === '1' && <Icon name="dollar" className="dollar" />}
                          </Link>
                        )}
                        <Styles.Date>
                          {val?.from_client_or_staff === 'client' ? (
                            <Styles.UserNameContainer to="/dashboard">
                              <P className="user">User: </P>
                              <P className="username"> {val?.username}</P>
                              <Icon name="warning circle" className="circle" />
                            </Styles.UserNameContainer>
                          ) : (
                            <P className="onlyUser"> {val?.username}</P>
                          )}
                          {val?.date_ago_en}
                        </Styles.Date>
                      </Styles.DateSC>
                    </Styles.Div1>
                    <Styles.Line bg={val.secret}>
                      <Icon name="circle" />
                    </Styles.Line>
                    <Styles.Div3>
                      <Styles.DetailSC bg={val?.from_client_or_staff === 'client'} secret={val.secret}>
                        <Styles.IPSC bg={val?.from_client_or_staff === 'client'}>
                          <P className="ip">{moment(val?.date_local).format('LLL')}</P>
                          {val.ipnumber !== '' && (
                            <>
                              <Icon className="dot" name="circle" />
                              <P>from IP number {val?.ipnumber}</P>
                            </>
                          )}
                        </Styles.IPSC>
                        <ReactMarkdown className="line-break">{Base64.decode(val?.message)}</ReactMarkdown>
                      </Styles.DetailSC>
                      {val.secret && (
                        <Styles.ReplyContainer>
                          <div>
                            <P>
                              <strong>
                                {val?.from_client_or_staff === 'client'
                                  ? 'Customer has provided confidential information:'
                                  : 'You provided this confidential information:'}
                              </strong>
                            </P>
                            <P>
                              <i>{Base64.decode(val.secret)}</i>{' '}
                            </P>
                          </div>
                        </Styles.ReplyContainer>
                      )}
                    </Styles.Div3>
                  </Styles.ChatMobile>
                </Hidden>
                <Hidden only={['md', 'lg', 'xl']}>
                  <Styles.ChatMobile>
                    <Styles.Line>
                      <Icon name="circle" />
                    </Styles.Line>
                    <Styles.Chatlog>
                      <Styles.Div1>
                        <Styles.DateSC bg={val.from_client_or_staff === 'client'}>
                          <Styles.Date>
                            {val?.from_client_or_staff === 'client' ? (
                              <Styles.UserNameContainer to="/dashboard">
                                <P className="user">User: </P>
                                <P className="username"> {val?.username}</P>
                                <Icon name="warning circle" className="circle" />
                              </Styles.UserNameContainer>
                            ) : (
                              <P className="onlyUser"> {val?.username}</P>
                            )}
                            {val?.date_ago_en}
                          </Styles.Date>
                        </Styles.DateSC>
                      </Styles.Div1>
                      <Styles.Div3>
                        <Styles.DetailSC bg={val?.from_client_or_staff === 'client'} secret={val.secret}>
                          <Styles.IPSC bg={val?.from_client_or_staff === 'client'}>
                            <P className="ip">{moment(val?.date_local).format('LLL')}</P>
                            {val.ipnumber !== '' && (
                              <>
                                <Icon className="dot" name="circle" />
                                <P>from IP number {val?.ipnumber}</P>
                              </>
                            )}
                          </Styles.IPSC>
                          <ReactMarkdown className="line-break">{Base64.decode(val?.message)}</ReactMarkdown>
                        </Styles.DetailSC>
                        {val.secret !== '' && (
                          <Styles.ReplyContainer>
                            <div>
                              <P>
                                <strong>
                                  {val?.from_client_or_staff === 'client'
                                    ? 'Customer has provided confidential information:'
                                    : 'You provided this confidential information:'}
                                </strong>
                              </P>
                              <P>
                                <i>{Base64.decode(val.secret)}</i>{' '}
                              </P>
                            </div>
                          </Styles.ReplyContainer>
                        )}
                      </Styles.Div3>
                    </Styles.Chatlog>
                  </Styles.ChatMobile>
                </Hidden>
              </>
            ))}
        </Styles.Chat>
        {tickets?.status !== '0' ? (
          <>
            <ChatReplyEditor
              secret={secret}
              tickets={{
                string15: t('tickets.string15'),
                string16: t('tickets.string16'),
                string17: t('tickets.string17'),
                string18: t('tickets.string18'),
              }}
              Span={SPAN}
              handleAddReply={async (value) => {
                await handleAddReply(value, secret, () => {
                  setSecret('');
                  setEditorValue('');
                });
              }}
              ticketReplyLoading={addReplyLoading}
              setSecret={setSecret}
              setEditorValue={setEditorValue}
              Paragraph={P}
              editorValue={editorValue}
            />
            <Formik
              initialValues={initialValuesOfClosedTicket}
              validationSchema={validationSchemaOfClosedTicket}
              onSubmit={async (values) => await handleTicketClosed('close', values.closed_reopen_summary)}
            >
              {({ values, handleChange, handleBlur, errors, touched, handleSubmit }) => (
                <Form>
                  <div style={{ display: 'flex' }}>
                    <Styles.WidthDiv />
                    <Styles.ReplyChatContainer>
                      <P>To close this ticket, please provide a summary of the problem and how it was solved.</P>
                      <ErrorMessage
                        name={'closed_reopen_summary'}
                        render={(msg) => <span className="error_messageSty">{msg}</span>}
                      />
                      <textarea
                        name={'closed_reopen_summary'}
                        value={values['closed_reopen_summary']}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors['closed_reopen_summary']}
                        touched={touched['closed_reopen_summary']}
                        rows="4"
                        placeholder="please write a summary here..."
                        onKeyDown={(event) => handleKeyDown(event, handleSubmit)}
                      />
                      <CustomButton
                        isLoading={loadingTicketClosed}
                        type="submit"
                        title={
                          isHaveStaffNotes === '0' ? 'Close this ticket' : 'Close this ticket and related staff note'
                        }
                        buttonStyles={{
                          background: '#8552da',
                          marginTop: '1em',
                          float: 'right',
                        }}
                      />
                    </Styles.ReplyChatContainer>
                  </div>
                </Form>
              )}
            </Formik>
          </>
        ) : (
          <CustomButton
            // isLoading={loadingTicketClosed}
            type="submit"
            title="Re-open this ticket"
            buttonStyles={{
              background: '#8552da',
              margin: '2em 0',
              float: 'right',
            }}
          />
        )}
      </Styles.Container>
    </Styles.AllIssueSC>
  );
};

export default IssueChat;
